import classNames from 'classnames';
import React from 'react';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './chip.module.scss';

export interface ChipProps {
  /** The class name to apply */
  className?: string;
  /** Whether the chip is selected or not */
  isSelected?: boolean;
  /** The label to be displayed in the filter chip */
  label: string;
  /** An event that is triggered on clicking the chip */
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  /** An event that is triggered on clicking the close icon */
  onClickClose?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

const Chip = ({
  className,
  isSelected = false,
  label,
  onClick = undefined,
  onClickClose = undefined,
}: ChipProps) => {
  const { t } = useI18n();
  const shouldRenderCloseButton = Boolean(
    onClickClose || (onClick && isSelected),
  );

  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isSelected]: isSelected,
        [styles.hasCloseBtn]: shouldRenderCloseButton,
      })}
    >
      {onClick ? (
        <button className={styles.chipBtn} onClick={onClick} type="button">
          <Typography tag="span" tagStyle="bodySmall">
            {label}
          </Typography>
        </button>
      ) : (
        <div className={styles.chipLabel}>
          <Typography tag="span" tagStyle="bodySmall">
            {label}
          </Typography>
        </div>
      )}

      {shouldRenderCloseButton && (
        <button
          aria-label={t('items.common.words.close')}
          className={styles.closeBtn}
          onClick={onClickClose}
          type="button"
        >
          <Icon name="Close" size={16} />
        </button>
      )}
    </div>
  );
};

Chip.displayName = 'Chip';

export default Chip;
